<!--盘点单镜片-->
<template>
  <div>
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="10">
          <el-form-item label="仓库" :label-width="formLabelWidth" prop="cangkucode" size="small"
                        style="text-align: left;">
            <el-select v-model="form.cangkuname" placeholder="请选择" @change="changename"
                       :required="true" v-show="btnvisible">
              <el-option
                v-for="item in jxcstoreDataf"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item">
              </el-option>
            </el-select>
            <span v-if="!btnvisible">{{form.cangkuname}}&nbsp;&nbsp;<br>{{form.accdate}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <el-form-item label="货品名称" :label-width="formLabelWidth" prop="seedname" size="small"
                        style="text-align: left;">
            <CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindData" :isShowCheckBox="false"
                        v-model="form.seedname" :treeWidth="340" v-if="btnvisible"
                        :treeHeight="350" :searchText="form.seedname"
                        @check="checktree1"></CommonTree>
            <span v-else>{{form.seedname}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="btnvisible">
        <el-col :span="24">
          <div style="float: left;padding-left: 120px">{{subinfo}}</div>
          <div style="float: left;padding-left: 20px">
             <el-checkbox v-model="loadQicu" v-if="btnvisible">增量导入</el-checkbox>
            <el-button type="warning" size="mini" @click="exportExceltable" v-if="form.seedcode">导出</el-button>
            <template v-if="form.seedcode&&btnvisible">
              <template v-if="!isyinxin">
                <el-button type="warning" @click="importEdit" size="mini" >二维表导入</el-button>
                <el-button type="warning" @click="importEditV2" size="mini" >列表导入</el-button>
                <!--<a href="./static/file/镜片导入格式.xls">下载模板</a>-->
              </template>
              <template v-if="isyinxin">
                <el-button type="warning" @click="importEdit" size="mini" >导入隐形</el-button>
                <a href="./static/file/隐形导入格式.xls">下载模板</a>
              </template>
            </template>
            <input type="file" ref="fileupload1" style="display: none;" @change="change1($event)"/>
          </div>
          <div style="float: right;padding-right: 100px"><el-button type="warning" @click="add2Table" v-if="isyinxin&&btnvisible" size="mini">增 加</el-button></div>
       </el-col>
      </el-row>
      <el-row :gutter="20" v-if="form.needaudit == 1">
        <el-col :span="24">
          <div style="float: left;padding-left: 120px">{{subinfo}}</div>
          <div style="float: right;padding-right: 100px" v-if="form.needaudit == 1&&extendForm.storenumbers">
            <el-button type="success" @click="showChangepdd" v-if="!onauditchange">修改盘点单</el-button>
            <el-button type="primary" @click="saveChangepdd" v-if="onauditchange">保存修改</el-button>
            <el-button type="info" @click="onauditchange=false" v-if="onauditchange">取消修改</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="备注" :label-width="formLabelWidth">
            <el-input
              type="textarea" v-if="btnvisible||onauditchange"
              :rows="1"
              v-model="form.remark">
            </el-input>
            <span v-else>{{form.remark}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="二维表" :label-width="formLabelWidth" v-show="form.filltemplate!=30">
            <el-table  :data="tableData" v-if="isyinxin"   size="mini"  stripe  style="width: 100%;">
              <el-table-column
                prop="certorg" :show-overflow-tooltip="true"
                label="厂家"
                align="left" width="100"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="certno" :show-overflow-tooltip="true"
                label="注册证号"
                align="left" width="120"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="batchno" :show-overflow-tooltip="true"
                label="批次号"
                align="left" width="120"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="endtime" :show-overflow-tooltip="true"
                label="失效日期"
                align="left"  width="100"
                header-align="center">
                <template slot-scope="scope">
                  {{scope.row.endtime?(scope.row.endtime.split(' ')[0]):''}}
                </template>
              </el-table-column>
              <el-table-column
                prop="Y"
                label="球镜"
                align="left"
                width="70"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="X"
                label="柱镜"
                align="left"
                width="70"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="P"
                label="库存"
                align="center" v-if="btnvisible||showKucun||onauditchange"
                width="70"
                header-align="center">
                <template slot-scope="scope">
                  <span style="color: red;font-weight: bolder" v-if="scope.row.P>scope.row.totalnumber">{{scope.row.P}}</span>
                  <span style="color: blue;font-weight: bolder" v-if="scope.row.P<scope.row.totalnumber">{{scope.row.P}}</span>
                  <span v-if="scope.row.P==scope.row.totalnumber">{{scope.row.P}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="totalnumber"
                label="盘点数"
                align="center"
                width="90"
                header-align="center">
                <template slot-scope="scope">
                  <el-input-number :controls="false" style="width: 100%" :min="0" size="small" v-if="btnvisible||onauditchange" v-model="scope.row.totalnumber"
                                   onfocus="this.select()"
                                   @change="yxTotal"></el-input-number>
                  <span v-else>{{scope.row.totalnumber}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="差异数"
                align="center"
                header-align="center" v-if="btnvisible||showKucun||onauditchange"
                width="80">
                <template slot-scope="scope">
                  <span> {{calNum(scope.row)}}</span>
                </template>
              </el-table-column>
            </el-table>
            <TwoDimensionalTable ref="referweibiao" @num="subData" v-if="!isyinxin" :readonly="!(btnvisible||onauditchange)" :precision="0" :isMakeInvent="true" :erweitable="erweitable" :cutHeight="cutHeight"></TwoDimensionalTable>
          </el-form-item>
          <el-form-item label="右眼" :label-width="formLabelWidth" v-show="form.filltemplate==30" style="display: inline-block">
            <TwoDimensionalTable ref="referweibiaoright"  :isMakeInvent="true" :precision="0" :readonly="!(btnvisible||onauditchange)" :cutHeight="cutHeight" :erweitable="erweitableright" style="width: 200px"></TwoDimensionalTable>
          </el-form-item>
          <el-form-item label="左眼" :label-width="formLabelWidth" v-show="form.filltemplate==30"
                        style="display: inline-block">
            <TwoDimensionalTable ref="referweibiaoleft"  :isMakeInvent="true" :precision="0" :readonly="!(btnvisible||onauditchange)" :cutHeight="cutHeight" :erweitable="erweitableleft" style="width: 200px"></TwoDimensionalTable>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <AddYinXing ref="AddYinXing1" @afterAddYX="afterAddYX" :lens="true"></AddYinXing>
    <!--<div slot="footer" class="dialog-footer">-->
      <!--<el-button @click="close()">取 消</el-button>-->
      <!--<el-button type="warning" @click="toZero(false)" plain v-if="btnvisible">清零</el-button>-->
      <!--<el-button type="warning" @click="toZero(true)" plain v-if="btnvisible">还原</el-button>-->
      <!--<el-button type="primary" @click="saveData" v-if="btnvisible" :loading="loading">保 存</el-button>-->
     <!---->
    <!--</div>-->
  </div>
</template>


<script>
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import AddYinXing from './AddYinXing';
  import {exportExcel} from '@/api/file'
  import {getControlData,getPrice} from '@/api/set/goodsprice';
  import {inventorySave} from '@/api/set/jxcstoreform';
  import {looklist} from '@/api/set/jxcstoreformdetail';
  import {getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import {formatTimeToStr} from '@/plugin/Date';
  import {getListData as listCert} from '@/api/set/certmanage'

  export default {
    name: 'MakeInventoryEdit',
    msg: '盘点单',
    data() {
      return {
        addvisible: true,
        showKucun:false,
        costpricebook: {},
        onauditchange:false,
        BookContent: [],
        loadQicu:false,
        isyinxin:false,
        tableData:[],
        guids: '',//商品编码
        erweitable: [],//二维表
        erweitableleft: [],//左眼二维表
        erweitableright: [],//右眼二维表
        BookContentLeft: [],
        BookContentRight: [],
        xcolumn:[],
        ycolumn:[],
        BookContent: [],
        categorycode:'',
        subinfo:'',
        storenum:0,
        isexcel:false,
        form: {  //表单数据
          accdate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
          cangkucode: '',
          cangkuname: '',
          packagesizes: '',
          seedcode: '',
          seedname: '',
          needaudit:'',
          status: 10,
          formtype: 74,
          filltemplate: '10',
          auditcontent:'',
          remark: '',
          totalnumber: 0,
          physicalstore:'',
          physicalstorecode:'',
          barcode:'',
          unitguid:'',
          changeunitguid:'',
        },
        extendForm:{
          storenumbers:null,
          yinxincert:null,
        },
        packagesizes: [],//存储盘点数据
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          cangkucode: [
            {required: true, message: '请选择仓库', trigger: 'blur'},
          ],
          seedname: [
            {required: true, message: '请选择货品', trigger: 'change'},
          ],
        },
      }
    },
    props:{
      jxcstoreDataf:[],
      btnvisible:false,
      loading:false,
      cutHeight:290,
    },
    methods: {
      calNum(row) {
        if (!row.totalnumber)
          row.totalnumber = 0;
        if (!row.P)
          row.P = 0;
        if (row.P == row.totalnumber)
          return '';
        return -(row.P - row.totalnumber);
      },
      close(){
        this.$emit('close');
      },
      //导入二维表
      importEdit() {
        this.isexcel=false;
        this.$refs.fileupload1.value = ""
        this.$refs.fileupload1.click()
      },
      importEditV2(){
        this.isexcel=true;
        this.$refs.fileupload1.value = ""
        this.$refs.fileupload1.click()
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
              let arr = []
              let obj = {}
              if(this.isyinxin){
                this.toZero(false);
                for(let i in data){
                  var item=data[i]
                  var Y = parseFloat(item["球镜"]);
                  var X = parseFloat(item["柱镜"]);
                  var P = parseInt(item["数量"]);
                  if(!P||P<=0) continue;
                  var batchno=item["批次号"];
                  if(!batchno) continue;
                  if(!Y) Y=0;
                  if(!X) X=0;

                  var hasValue=false;
                  for(let j in this.tableData){
                    var row=this.tableData[j];
                    if(parseFloat(row.X)==X&&parseFloat(row.Y)==Y&&row.batchno==batchno){
                      row.totalnumber+=P;
                      hasValue=true;
                      break;
                    }
                  }
                  if(!hasValue){
                    if(!item["有效期"]||!item["厂家"]||!item["证号"]) continue;
                    var d=new Date(item["有效期"]);
                    this.tableData.push({
                      X:X.toFixed(2),
                      Y:Y.toFixed(2),
                      packagesize:  '{"X":"' + X.toFixed(2) + '","Y":"' + Y.toFixed(2) + '"}',
                      totalnumber: P,
                      P:0,
                      batchno: batchno,
                      certno: item["证号"],
                      certorg:item["厂家"],
                      endtime:d.getFullYear()+"-"+this.padLeft(d.getMonth()+1)+"-"+this.padLeft(d.getDate())
                    });
                  }
                }
                this.yxTotal();
                this.sortYX();
              }else if(this.isexcel){
                for(let i in data){
                  var item=data[i]
                  if(item["球镜"]==null) continue;
                  if(item["柱镜"]==null) continue;
                  var Y = parseFloat(item["球镜"]);
                  var X = parseFloat(item["柱镜"]);
                  var P = parseInt(item["数量"]?item["数量"]:item["盘点数量"]);
                  if(!P||P==0) continue;
                  if(!Y) Y=0;
                  if(!X) X=0;

                  var hasValue=false;
                  for(let j in arr){
                    var row=arr[j];
                    if(parseFloat(row.X)==X&&parseFloat(row.Y)==Y){
                      row.P+=P;
                      hasValue=true;
                      break;
                    }
                  }
                  if(!hasValue){
                    arr.push({
                      X:X.toFixed(2),
                      Y:Y.toFixed(2),
                      P:P
                    });
                  }
                }
                this.$refs.referweibiao.initBook(this.costpricebook, arr, null, this.BookContent)
              } else {
                data.forEach((item) => {
                  let Y = ""
                  for (let X in item) {
                    obj = {}
                    if (X == "球\\柱") {
                      Y = parseFloat(item[X]).toFixed(2)
                    } else {
                      if (typeof parseFloat(item[X]) === 'number' && !isNaN(parseFloat(item[X]))) {
                        obj = {"X": parseFloat(X).toFixed(2), "Y": Y, "P": parseFloat(item[X])}
                        if (this.type) {
                          obj.type = this.type
                        }
                        arr.push(obj)
                      }
                    }
                  }
                })
                this.$refs.referweibiao.initBook(this.costpricebook, arr, null, this.BookContent)
              }
            }
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      padLeft(num){
        if(num<10) return '0'+num.toString();
        return num.toString();
      },
      add2Table() {
        this.$refs.AddYinXing1.show(this.form.seedcode, this.costpricebook, this.tableData);
      },
      showChangepdd() {
        this.onauditchange = true;
      },
      saveChangepdd() {
        this.form.changeunitguid = this.form.unitguid;
        this.saveData();
      },
      afterAddYX(row) {
        this.tableData.push(row)
        this.yxTotal();
        this.sortYX();
      },
      subData(pSub) {
        if(!pSub) pSub=0;
        if (this.loadQicu) {
          this.subinfo = '盘点：' + (pSub+this.storenum) + ' 、原库存：' + this.storenum + ' 、' + (pSub == 0 ? '无差异！' : ((pSub > 0 ? '盘盈：' : '盘亏：') + pSub));
        } else {
          var cSub = pSub - this.storenum;
          this.subinfo = '盘点：' + pSub + ' 、原库存：' + this.storenum + ' 、' + (cSub == 0 ? '无差异！' : ((cSub > 0 ? '盘盈：' : '盘亏：') + cSub));
        }
      },
      show(cangkucode) {
        this.initForm();
        this.loadQicu=false;
        this.showKucun=false;
        this.changename({cangkucode:cangkucode});
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.loading = true
            //一个二维表,过滤数量为空和0
            //10现片，20定制片，30区分左右眼
            //存储二维表过滤后的数据
            var arr = [];
            var barcode = [];
            if (this.form.filltemplate == 10 || this.form.filltemplate == 20 || this.form.filltemplate == 30) {
              if(this.isyinxin){
                for(var i in this.tableData) {
                  var Row = this.tableData[i]
                  Row.oldtn=Row.totalnumber;
                  Row.seedcode=this.form.seedcode;
                  Row.seedname=this.form.seedname;
                  var item = {
                    X: Row.X,
                    Y: Row.Y,
                    P: parseInt(Row.totalnumber) - parseInt(Row.P)
                  };
                  if (item.P != undefined && item.P != 0) {
                    arr.push(item);
                    Row.totalnumber=item.P;
                    barcode.push(Row);
                  }
                }
              }else if (this.form.filltemplate == 10 || this.form.filltemplate == 20) {
                arr = this.difference(this.erweitable, this.BookContent);
              } else if (this.form.filltemplate == 30) {
                arr = arr.concat(this.difference(this.erweitableleft, this.BookContentLeft, "L"),
                  this.difference(this.erweitableright, this.BookContentRight, "R"));
              }
              // this.form.remark=this.form.remark+" "+this.subinfo;
              this.form.auditcontent=this.subinfo;

              this.form.packagesizes = JSON.stringify(arr);
            } else if (this.form.filltemplate == 40) {
              if (this.form.totalnumber == 0) {
                this.form.changeunitguid=''
                this.$message({
                  message: '请输入盘点数量',
                  type: 'warning'
                })
                this.loading = false
                return
              }
            }
            this.form.physicalstore=this.form.seedname
            this.form.physicalstorecode=this.form.seedcode
            this.form.barcode= barcode.length > 0 ? JSON.stringify(barcode) : ''
            if(this.form.accdate){
              var accD=new Date(this.form.accdate);
              this.form.accdate=accD.getFullYear() + '-' + (accD.getMonth() + 1) + '-' + accD.getDate();
            }
            inventorySave(this.form).then(response => {
              if(this.isyinxin){
                for(var i in this.tableData) {
                  var Row = this.tableData[i]
                  Row.totalnumber=Row.oldtn;
                }
              }

              if(response.data.code==0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                //刷新列表
                this.$emit('bindGrid');
                if (this.form.changeunitguid) {
                  this.onauditchange = false;
                } else {
                  this.$emit('close');
                }
              }else{
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
              this.form.changeunitguid='';
              this.loading = false
            });
            //
          } else {
            this.form.changeunitguid=''
            this.loading = false
          }
        })

      },
      difference(newNum,oldNum,type) {//差异:新的数量，原始数量
        var changeRow = []
        if(this.loadQicu) {
          for (let i in newNum) {
            var hasV = false;
            for (let m in newNum[i]) {

              var item = newNum[i][m];
              var floatX = parseFloat(item.X);
              var floatY = parseFloat(item.Y);
              var New = item.P;
              if (New == null || New == '')
                New = 0;

              //原始库存量
              if (parseInt(New) != 0) {
                var arr = {
                  X: floatX.toFixed(2),
                  Y: floatY.toFixed(2),
                  P: parseInt(New)
                };
                if (type)
                  arr.type = type;
                changeRow.push(arr)
              }
            }
          }
          return changeRow;
        }

        var initStoreNum=JSON.parse(JSON.stringify(oldNum));
        //新录入的库存量
        for (let i in newNum) {
          var hasV = false;
          for (let m in newNum[i]) {

            var item = newNum[i][m];
            var floatX = parseFloat(item.X);
            var floatY = parseFloat(item.Y);
            var New = item.P;
            if (New == null || New == '')
              New = 0;

            //原始库存量
            var Old = 0;
            for (let j in initStoreNum) {
              if (parseFloat(initStoreNum[j].X) == floatX && parseFloat(initStoreNum[j].Y) == floatY) {
                Old = initStoreNum[j].P;
                initStoreNum[j].hasSet="1";
                if (Old == null || Old == '')
                  Old = 0;
                break;
              }
            }

            if ((parseInt(New) - parseInt(Old)) != 0) {
              //{"X":"0.00","Y":"-2.25","type":"L"}
              var arr = {
                X: floatX.toFixed(2),
                Y: floatY.toFixed(2),
                P: parseInt(New) - parseInt(Old)
              };
              if (type)
                arr.type = type;
              changeRow.push(arr)
            }

          }
        }

        //补全超光度的
        for (let j in initStoreNum) {
          if (initStoreNum[j].hasSet == "1" || !initStoreNum[j].P || initStoreNum[j].P == 0) continue;
          var arr = {
            X: parseFloat(initStoreNum[j].X).toFixed(2),
            Y: parseFloat(initStoreNum[j].Y).toFixed(2),
            P: -parseInt(initStoreNum[j].P)
          };
          if (type)
            arr.type = type;
          changeRow.push(arr)
        }
        return changeRow;
      },
      toFormat() {
        this.toZero(true);
      },
      toZero(isback) {
        if(this.isyinxin) {
          for (let i in this.tableData) {
            this.tableData[i].totalnumber = isback ? this.tableData[i].P : 0;
          }
          return
        }
        if (this.form.cangkucode && this.form.seedcode) {
          if (this.$refs.referweibiao)
            this.$refs.referweibiao.initBook(this.costpricebook, isback ? this.BookContent : [], null, this.BookContent)
          if (this.$refs.referweibiaoright)
            this.$refs.referweibiaoright.initBook(this.costpricebook, isback ? this.BookContentRight : [], null, this.BookContentRight)
          if (this.$refs.referweibiaoleft)
            this.$refs.referweibiaoleft.initBook(this.costpricebook, isback ? this.BookContentLeft : [], null, this.BookContentLeft)
        }
      },
      initData(response) {
        this.initForm()
        this.btnvisible = false;
        this.showKucun = true;
        for (let i in  this.form) {
          this.form[i] = response.data.obj[i];
        }

        this.extendForm.storenumbers=response.data.obj.storenumbers;
        this.extendForm.yinxincert=response.data.obj.yinxincert;
        if (response.data.barcode && response.data.barcode.length > 0) {
          this.isyinxin = true;
        }
        if (response.data.barcode && response.data.barcode.length > 0) {
          this.form.filltemplate = 10;
          this.tableData = response.data.barcode;
          for (let i in this.tableData) {
            if (this.tableData[i].packagesize) {
              this.tableData[i].X = JSON.parse(this.tableData[i].packagesize).X;
              this.tableData[i].Y = JSON.parse(this.tableData[i].packagesize).Y;
            }
          }
          this.subinfo = '';
        } else {
          if (this.form.packagesizes) {
            var packagesize = JSON.parse(this.form.packagesizes)
            packagesize.forEach(o => {
              o.P = parseInt(o.P);
              if (o.type != undefined) {
                if (o.type == 'L') {
                  this.BookContentLeft.push(o)
                } else if (o.type == 'R') {
                  this.BookContentRight.push(o)
                }
              } else {
                this.BookContent.push(o);
              }
            })
            if (this.form.needaudit == 1||this.extendForm.storenumbers) {

            } else {
              this.getXYRange()
            }
          }
        }
        if (this.form.needaudit == 1||this.extendForm.storenumbers) {//审核中的 显示当前库存
          this.checktree1(this.form.seedcode, this.form.seedname, [{
            parentId: this.isyinxin ? '010' : '001',
            attributes: {filltemplate: this.form.filltemplate}
          }]);
          return;
        } else {
          this.showKucun = false;
        }
      },
      exportExceltableYX() {
        let header1 = ["厂家", "注册证号", "批次号", "失效日期", "球镜", "柱镜", "库存数"];
        let column1 = ["certorg", "certno", "batchno", "endtime", "Y", "X","P"];
        var name =this.form.seedname;
        var biaoti = []
        biaoti.push(formatTimeToStr(new Date()))
        biaoti.push("")
        biaoti.push("")
        biaoti.push(name)

        var data=[];
        var totalN=0;
        for(let i in this.tableData){
          totalN+=this.tableData[i].P;
          this.tableData[i].endtime=this.tableData[i].endtime?(this.tableData[i].endtime.split(' ')[0]):'';
          data.push(this.tableData[i])
        }
        data.push({batchno:'合计',P:totalN});

        name = name + formatTimeToStr(new Date());
        this.$exportExcel(header1, column1, data, name, biaoti)
      },
      exportExceltable() {
        if(this.isyinxin) {
          this.exportExceltableYX();
          return;
        }

        var RL = this.form.filltemplate == 30 ? 'R/L' : ''

        this.xcolumn = []
        this.ycolumn = []
        var content =this.costpricebook.BookContent
        var dataXY = this.form.filltemplate == 30 ? this.BookContentRight : this.BookContent
        if (content.length > 0) {
          content.forEach(o => {
            let temp1 = this.xcolumn.filter(item => {
              return item == o.X
            })
            if (temp1.length == 0) {
              this.xcolumn.push(o.X.toFixed(2).toString())
            }
            let temp2 = this.ycolumn.filter(item => {
              return item == o.Y
            })
            if (temp2.length == 0) {
              this.ycolumn.push(o.Y.toFixed(2).toString())
            }
          })
        }
        this.xcolumn.sort((a, b) => {
          return parseFloat(b) - parseFloat(a)
        })
        this.xcolumn.unshift('球\\柱')
        this.xcolumn.push("合计")
        this.ycolumn.sort((a, b) => {
          return parseFloat(b) - parseFloat(a)
        })
        //下面按照格式拼接
        let data = [] //导出的数据,
        this.ycolumn.forEach(y => {
          let heji = 0;
          let temp1 = {}
          temp1["球\\柱"] = y
          this.xcolumn.forEach(x => {
            for (let i in dataXY) {
              if (dataXY[i].X == x && dataXY[i].Y == y) {
                temp1[x] = dataXY[i].P
                if (Number(dataXY[i].P))
                  heji += dataXY[i].P
                break;
              }
            }
          })
          temp1['合计'] = heji
          data.push(temp1)
        })
        //导出合计计算
        var hj = {"球\\柱": "合计"}
        var zhj = 0;
        this.xcolumn.forEach(x => {
          if (x != "球\\柱" && x != "合计") {
            hj[x] = 0
            data.forEach(item => {
              if (Number(item[x])) {
                hj[x] = hj[x] + item[x]
              }
            })
            zhj += hj[x]
          }
          //计算总合计
          if (x == "合计") {
            hj[x] = zhj
          }
        })
        data.push(hj)
        let title = this.form.seedname + "【" + new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "】"

        var biaoti = []
        let header1 = this.xcolumn.map(item => parseFloat(item) > 0 ? "+" + item : item)
        // biaoti.push(seedcode)
        biaoti.push(formatTimeToStr(new Date()))
        biaoti.push("")
        biaoti.push("")
        biaoti.push(this.form.seedname)

        if (RL) {
          var dataexcel = {
            initContentLeft: JSON.stringify(this.initContentLeft),
            initContentRight: JSON.stringify(this.initContentRight),
            seedcode: this.form.seedcode,
            seedname: this.form.seedname,
            businessType: 'MakeInventoryEdit'
          }
          exportExcel(dataexcel, title)
        } else {
          this.$exportExcel(header1, this.xcolumn, data, title, biaoti)
        }
      },
      //初始化
      initForm() {
        this.costpricebook = {}
        if (this.$refs.form1 !== undefined)
          this.$refs.form1.resetFields();
        this.form.seedname = ""
        this.form.seedcode = ""
        this.form.discountdetail = ""
        this.zhujing = []
        this.qiujing = []
        this.onauditchange=false;
        this.form.remark = ''
        this.form.totalnumber = 0
        this.form.cangkucode = ''
        this.form.cangkuname = ''
        this.form.unitguid='';
        this.form.changeunitguid='';
        this.form.accdate = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate();

        this.form.needaudit=''
        this.isyinxin = false
        this.tableData = []
        this.categorycode = ''
        this.BookContent = []//正常二维表
        this.BookContentLeft = []//左二维表
        this.BookContentRight = []//右二维表
        this.loading = false
        this.btnvisible = true;
        this.form.enabled = 1
        this.erweitable = [];
        this.erweitableleft = []
        this.erweitableright = []
        this.index = ''
        this.storenum = 0;
        this.showKucun = false;
        this.extendForm.storenumbers=null;
        this.extendForm.yinxincert=null;
        this.subData(0);
        if (this.$refs.treedept != undefined) {
          this.$refs.treedept.reset();
        }
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.$refs.referweibiaoleft) {
          this.$refs.referweibiaoleft.initForm()
        }
        if (this.$refs.referweibiaoright) {
          this.$refs.referweibiaoright.initForm()
        }
      },
      //商品树
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({nostock: 1,filltemplates:'10;30'})
        })
      },
      //选择商品树所执行的方法
      checktree1(guids, names, arr) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i]['attributes']['filltemplate']) {
            this.form.filltemplate = arr[i]['attributes']['filltemplate']
            break
          }
        }
        this.form.seedcode = guids//商品编码
        this.form.seedname = names//商品名称
        this.categorycode = arr[0].parentId;

        this.costpricebook = {}
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.form.seedname == "") {
          this.$message({
            message: '请选择货品',
            type: 'warning'
          })
          return
        }

        this.isyinxin = this.categorycode.startsWith("010");
        if (this.isyinxin) {
          listCert({offset: 0, limit: 1, certtype: 1, seedcode: this.form.seedcode}).then(response => {
            if (!(response.data.code == 0 && response.data.obj.rows.length > 0)) {
              this.isyinxin=false;
            }
            this.getXYRange();
          })
        } else {
          this.getXYRange();
        }
      },
      //二维表展示范围
      getXYRange() {
        //获取库存
        getPrice({seedcode: this.form.seedcode}).then((response) => {
          if (response.data.code == 0 && response.data.obj) {
            this.costpricebook = response.data.obj
          } else {
            this.costpricebook = {}
          }
          if (this.form.cangkucode) {
            if (this.btnvisible||this.showKucun) {
              this.createPriceBook()
            } else {//查看状态
              if (this.form.filltemplate == 30) {
                this.$refs.referweibiaoleft.initBook(this.costpricebook, this.BookContentLeft)
                this.$refs.referweibiaoright.initBook(this.costpricebook, this.BookContentRight)
              } else if (this.form.filltemplate != 40) {
                this.$refs.referweibiao.initBook(this.costpricebook, this.BookContent)
              }
            }
          }
        })
      },
      sortYX(){
        this.tableData.sort(function (a, b) {
          let aP = JSON.parse(a.packagesize)
          let bP = JSON.parse(b.packagesize)
          if (aP.X == bP.X) {
            if(aP.Y=='0.00') aP.Y="-0.00";
            if(bP.Y=='0.00') bP.Y="-0.00";
            return aP.Y.localeCompare(bP.Y)
          }
          else {
            if(aP.X=='0.00') aP.X="-0.00";
            if(bP.X=='0.00') bP.X="-0.00";
            return aP.X.localeCompare(bP.X)
          }
        });
      },
      yxTotal(){//隐形合计
        var subnum=0;
        for(let i in this.tableData){
          subnum+=this.tableData[i].totalnumber;
        }
        this.subData(subnum);
      },
      changename(val) {
        this.form.cangkucode = val.cangkucode;
        for(let i in this.jxcstoreDataf){
          if(this.jxcstoreDataf[i].cangkucode==val.cangkucode){
            this.form.cangkuname = this.jxcstoreDataf[i].cangkuname;
            break;
          }
        }
        if (this.form.seedcode)
          this.createPriceBook()
      },
      createPriceBook() {
        if (this.extendForm.storenumbers!=null) {
          this.subinfo=this.form.auditcontent;
          if (this.isyinxin) {
            this.initWithStoredetail(this.extendForm.yinxincert);
          }else{
            var sn=this.extendForm.storenumbers;
            for(let i in sn){
              sn[i].deliverying=sn[i].delin;
              sn[i].subtractnum=sn[i].closen;
              sn[i].seedcode=sn[i].SeedCode;
              sn[i].packagesize=sn[i].Packagesize;
            }
            this.initWithStoredetail(sn);
          }
          return;
        }

        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1
        this.storenum = 0;
        //取当前库存
        getGoodsListWithStoreDetail({
          seedcode: this.form.seedcode,
          cangkucode: this.form.cangkucode,
          minyear: yearnow,
          minmonth: monthnow,
          maxyear: yearnow,
          maxmonth: monthnow,
          nostock: 1, nolimit: '1', notransfernum: '1', nobuynum: '1',
          showyinxing: this.isyinxin ? "1" : "0"
        }).then(resStore => {//nodeliverying: '1',
          this.initWithStoredetail(resStore.data.obj);
        });
      },
      initWithStoredetail(storeData){
        var AddtableData= JSON.parse(JSON.stringify(this.tableData));
        var AddBookContent= JSON.parse(JSON.stringify(this.BookContent));;
        var AddBookContentLeft= JSON.parse(JSON.stringify(this.BookContentLeft ));
        var AddBookContentRight= JSON.parse(JSON.stringify(this.BookContentRight));

        this.tableData = []
        this.BookContent = []//正常二维表
        this.BookContentLeft = []//左二维表
        this.BookContentRight = []//右二维表

        storeData.forEach(o => {
          o.subtractnum = o.subtractnum - o.deliverying;
        })

        if (this.isyinxin) {
          storeData.forEach(o => {
            let ob = JSON.parse(o.packagesize)
            o.X = ob.X;
            o.Y = ob.Y;
            o.P = o.totalnumber;
            this.storenum += o.totalnumber;
            this.tableData.push(o);//本次盘点的隐形数量
          })

          if(this.showKucun){
            for(let i in AddtableData){
              var newRow = this.existXY(this.tableData, AddtableData[i].X, AddtableData[i].Y, AddtableData[i].batchno);
              if(newRow!=null){
                newRow.totalnumber+=AddtableData[i].totalnumber;
              }else{
                AddtableData[i].P=0;
                this.tableData.push(AddtableData[i]);
              }
            }
          }
          this.sortYX();
          this.yxTotal();
          return;
        }
        else if (this.form.filltemplate == 30) {

          for (let i in storeData) {
            var pc = JSON.parse(storeData[i].packagesize)
            if (pc.type == 'L') {
              this.BookContentLeft.push({X: pc.X, Y: pc.Y, P: storeData[i].subtractnum});
            }
            else {
              this.BookContentRight.push({X: pc.X, Y: pc.Y, P: parseInt(storeData[i].subtractnum)});
            }
          }
          if (this.BookContentLeft.length == 0) {
            this.BookContentLeft.push({X: "0.00", Y: "0.00", P: 0});
          }
          if (this.BookContentRight.length == 0) {
            this.BookContentRight.push({X: "0.00", Y: "0.00", P: 0});
          }
          var setValueLeft=JSON.parse(JSON.stringify(this.BookContentLeft));
          var setValueRight=JSON.parse(JSON.stringify(this.BookContentRight));
          if(this.showKucun) {
            for (let i in AddBookContentLeft) {
              var newRow = this.existXY(setValue, AddBookContentLeft[i].X, AddBookContentLeft[i].Y);
              if (newRow != null) {
                newRow.P += AddBookContentLeft[i].P;
              } else {
                setValueLeft.push(AddBookContentLeft[i]);
              }
            }
            for (let i in AddBookContentRight) {
              var newRow = this.existXY(setValue, AddBookContentRight[i].X, AddBookContentRight[i].Y);
              if (newRow != null) {
                newRow.P += AddBookContentRight[i].P;
              } else {
                setValueRight.push(AddBookContentRight[i]);
              }
            }
          }

          this.$refs.referweibiaoleft.initBook(this.costpricebook, setValueLeft, null, this.BookContentLeft)
          this.$refs.referweibiaoright.initBook(this.costpricebook, setValueRight, null, this.BookContentRight)

        } else if (this.form.filltemplate != 40) {
          for (let i in storeData) {
            var pc = JSON.parse(storeData[i].packagesize)
            this.BookContent.push({X: pc.X, Y: pc.Y, P: parseInt(storeData[i].subtractnum)});
            this.storenum += storeData[i].subtractnum;
          }
          if (this.BookContent.length == 0) {
            this.BookContent.push({X: "0.00", Y: "0.00", P: 0});
          }
          var setValue=JSON.parse(JSON.stringify(this.BookContent));
          if(this.showKucun){
            for(let i in AddBookContent){
              var newRow = this.existXY(setValue, AddBookContent[i].X, AddBookContent[i].Y);
              if(newRow!=null){
                newRow.P+=AddBookContent[i].P;
              }else{
                setValue.push(AddBookContent[i]);
              }
            }
          }
          this.$refs.referweibiao.initBook(this.costpricebook, setValue, null, this.BookContent);
        }
      },
      existXY(rows,X,Y,batchno){
        for(let i in rows){
          if(parseFloat(rows[i].Y).toFixed(2)==parseFloat(Y).toFixed(2)&&parseFloat(rows[i].X).toFixed(2)==parseFloat(X).toFixed(2)
          &&(!batchno||batchno==rows[i].batchno)){
            return rows[i];
          }
        }
        return null;
      }
    },
    components: {
      TwoDimensionalTable,
      AddYinXing
    },

    mounted() {
      this.loadQicu=false;
    },
  }
</script>

<style scoped>
  .titlecolor {
    color: #20A0FF
  }

  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .erweitable td {
    border: 1px solid #E0DFDF;
    min-width: 80px;
    max-width: 100px;
    text-align: center;
    vertical-align: center;
  }

  .erweitable .content {
    border: none;
    padding: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/warehouse/MakeInventoryEdit.vue